export const TextEffectsOutlineOutViewerType =
  'wixui.TextEffectsOutlineOut' as const;
export const TestIds = {
  viewer: {
    container: 'TextEffectsOutlineOut-container',
    text: 'TextEffectsOutlineOut-text',
  },
} as const;

export const angleConfig = {
  start: 0,
  end: 360,
  step: 45,
};
